export const QA_NAME_CALENDAR_PAGE = 'calendar'
